module.exports = __webpack_public_path__ + "assets/img/drag.4a19e202.svg";